// src/config/constants.js
// Application constants and configuration

// Default customer IDs
export const DEFAULT_CUSTOMERS = {
  WALKING_CUSTOMER: '698997d90f38e268289e5ca3', 
  ///'695a94d59c15ef75c1542dad', uat walking // Default walking customer for POS orders - mobile: 0000000000
};

// Order types
export const ORDER_TYPES = {
  DINE_IN: 'dine_in',
  TAKE_AWAY: 'take_away', 
  DELIVERY: 'delivery'
};

// Delivery providers
export const DELIVERY_PROVIDERS = {
  UBER: 'uber',
  PICKME: 'pickme'
};

// Stock status
export const STOCK_STATUS = {
  IN_STOCK: 'in_stock',
  OUT_OF_STOCK: 'out_of_stock',
  LOW_STOCK: 'low_stock'
};

export default {
  DEFAULT_CUSTOMERS,
  ORDER_TYPES,
  DELIVERY_PROVIDERS,
  STOCK_STATUS
};
